import { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { LuSendHorizontal } from "react-icons/lu";


const CreatePoll = ({ open, onClose, onCreate }) => {
    const [question, setQuestion] = useState("");
    const [options, setOptions] = useState(["", ""]);
    const [allowMultiple, setAllowMultiple] = useState(false);

    if (!open) return null;

    const addOption = () => options.length < 10 && setOptions([...options, ""]);
    const removeOption = (i) =>
        options.length > 2 && setOptions(options.filter((_, idx) => idx !== i));
    const changeOption = (i, val) => {
        const next = [...options];
        next[i] = val;
        setOptions(next);
    };

    const submit = () => {
        const trimmed = options.map(o => o.trim()).filter(Boolean);
        if (!question.trim() || trimmed.length < 2) return;
        onCreate({
            question: question.trim(),
            allowMultiple,
            options: trimmed,
        });
        // reset
        setQuestion("");
        setOptions(["", ""]);
        setAllowMultiple(false);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="w-full max-w-md rounded-2xl bg-[#1E1E1E] text-white shadow-xl p-6 ml-4 mr-4">
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-lg font-semibold">Create poll</h2>
                    <button className="text-gray-400 hover:text-white" onClick={onClose}>✕</button>
                </div>

                <div className="mb-6">
                    <label className="text-sm text-gray-400">Question</label>
                    <input
                        className="mt-1 w-full rounded-lg bg-[#2A2A2A] px-4 py-2 outline-none focus:ring-1 focus:ring-primary"
                        placeholder="Ask question"
                        value={question}
                        onChange={(e) => setQuestion(e.target.value)}
                    />
                </div>

                <div className="mb-6">
                    <label className="text-sm text-gray-400">Options</label>
                    {options.map((opt, i) => (
                        <div key={i} className="mt-2 flex items-center space-x-2">
                            <input
                                className="flex-1 rounded-lg bg-[#2A2A2A] px-4 py-2 outline-none focus:ring-1 focus:ring-primary"
                                placeholder="Add option"
                                value={opt}
                                onChange={(e) => changeOption(i, e.target.value)}
                            />
                            {i >= 2 && (
                                <button onClick={() => removeOption(i)} className="text-gray-400 hover:text-red-500">
                                    <FiMinus />
                                </button>
                            )}
                        </div>
                    ))}
                    <button onClick={addOption} className="mt-3 flex items-center text-primary hover:underline">
                        <FiPlus className="mr-1" /> Add option
                    </button>
                </div>

                <div className="mb-6 flex items-center">
                    <span className="flex-1 text-sm text-gray-400">Allow multiple answers</span>
                    <label className="relative inline-flex cursor-pointer items-center">
                        <input
                            type="checkbox"
                            className="peer sr-only"
                            checked={allowMultiple}
                            onChange={(e) => setAllowMultiple(e.target.checked)}
                        />
                        <div className="h-6 w-11 rounded-full bg-gray-600 transition peer-checked:bg-primary" />
                        <div className="absolute left-1 top-1 h-4 w-4 rounded-full bg-white transition peer-checked:translate-x-5" />
                    </label>
                </div>

                <div className="flex justify-end">
                    <button
                        onClick={submit}
                        className="flex items-center space-x-2 rounded-full bg-primary px-6 py-2 hover:bg-primary/80"
                    >
                        <span>Send</span>
                        <LuSendHorizontal />
                    </button>
                </div>
            </div>
        </div>
    );
}
export default CreatePoll;